import * as React from "react";
import { getParam } from "./getParam";
import { Meta } from "./AssetModal";
import useAssetData from "./useAssetData";

export function Asset() {
  const assetName = "" + getParam("name");
  const data = useAssetData(assetName);

  if (!data) {
    return (
      <div className="page">
        <p className="muted">Loading {assetName}…</p>
      </div>
    );
  }
  return (
    <div className="page stack">
      <div className="kicker">Asset</div>
      <h1 style={{ fontSize: 28, margin: 0 }}>{assetName}</h1>
      <Meta asset={data} />
    </div>
  );
}
